import {socket, host} from "./webRTC";

export default function fronLogger(token=null, message=null, type=null, source=null, device=null){
    Logger(token, message, type, source, device);
}

function Logger(token, message, type, source, device){
    if (device === null) {
        device = "kurento";
    }
    console.log(`Inside Logger. Message: ${message}, Source: ${source}, Type: ${type}`);
    let date = new Date();
    socket.emit('take log', {
        token: token,
        message: message,
        date: date,
        expireDate: new Date(date.getFullYear(), date.getMonth()+1, date.getDate(), date.getHours(), date.getMinutes()),
        source: source,
        type: type,
        device: device,
    });
}
